export default {"src":"/_next/static/media/delta-neutral.a7014dfb.svg","height":486,"width":486};